<template>
  <div class="companies">
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs
          :items="[
            { text: $t('meta.containers'), name: 'company_containers' },
            {
              text: container.name,
              name: 'company_container',
              params: { container_uuid: $route.params.container_uuid },
            },
            { text: $t('containers.addPicture') },
          ]"
        />
      </template>
    </SectionHeader>

    <div class="body-content cf">
      <CompanyNav />
      <div class="body">
        <div class="content-wrap">
          <header class="content-header cf">
            <h3>{{ $t('containers.addPicture') }}</h3>
            <div class="header-meta"></div>
          </header>
          <div class="content-body">
            <LoadingSpinner v-if="loading" />
            <div v-else>
              <form @submit.prevent="addImages" class="form" method="post">
                <div class="form-wrap">
                  <label for="container-image"
                    >{{ $t('containers.addPicture') }}{{ ` (${$t('meta.multipleAllowed')})` }}</label
                  >
                  <input id="container-image" type="file" accept="image/*" multiple @change="setImages" />
                </div>
                <input type="submit" :value="$t('meta.save')" class="button button-green button-100" />
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumbs from '@/components/BreadCrumbs/index.vue'
import LoadingSpinner from '@/components/LoadingSpinner'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav'

import containersApi from '@/api/container'

export default {
  name: 'company_container_type',
  data() {
    return {
      loading: true,
      company: {},
      container: {},
      newImages: [],
    }
  },
  components: {
    BreadCrumbs,
    CompanyNav,
    LoadingSpinner,
    SectionHeader,
  },
  methods: {
    addImages: async function () {
      if (this.newImages.length === 0) return
      const formData = new FormData()
      for (let i = 0; i < this.newImages.length; i++) {
        formData.append('images[]', this.newImages[i])
      }
      const successful = await containersApi.update(this.$route.params.container_uuid, formData)
      if (successful) {
        await this.$router.push(`/company/containers/${this.$route.params.container_uuid}`)
      }
    },
    setImages(event) {
      this.newImages = event.target.files
    },
  },
  async mounted() {
    this.container = await containersApi.get(this.$route.params.container_uuid)
    this.loading = false
  },
}
</script>
